"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";

import DeleteConfirmationDialog from "../../controls/DeleteConfirmationDialog.jsx";
import actions from "newApp/actions/SettingsActions";
import Settings from "newApp/entities/Settings";

export class LogoSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            overlayMessage: "",
            showDeleteLogoConfirmationDialog: false
        };

        this._handleLogoSaveClick = this._handleLogoSaveClick.bind(this);
        this._handleDeleteClick = this._handleDeleteClick.bind(this);
        this._handleBrowseClick = this._handleBrowseClick.bind(this);
        this._handleFilePickerOnChange = this._handleFilePickerOnChange.bind(this);
        this._handleLogoCancelClick = this._handleLogoCancelClick.bind(this);
        this._hideDeleteLogoConfirmationDialog = this._hideDeleteLogoConfirmationDialog.bind(this);
        this.deleteLogo = this.deleteLogo.bind(this);
    }

    componentDidMount() {
        this.props.getLogo(this.props.organizationId);
    }

    render() {
        const uploadErrorMessage = classNames("alert", "alert-danger", "col-md-12",
            !this.props.logo || this.props.logo.isValid ? "hidden" : "");

        return (
            <div id="LogoSettings" className="col-md-12">
                <div className="horizontal-line" />
                <div className="col-md-12">
                    <div className="col-md-6">
                        <div className={!this.props.logo ? "hidden" : "col-md-4"}
                            style={{ height: "65px", width: "200px", lineHeight: "55px" }}>
                            <img id="logoPreview"
                                style={{ maxHeight: "65px", maxWidth: "200px" }}
                                src={this.props.logo && this.props.logo.file ? this.props.logo.file.src : ""}
                                ref={(c) => this.logoPreview = c} />
                        </div>
                        <div className={this.props.logo ? "hidden" : "col-md-4"}
                            id="noLogoSelectedText"
                            style={{ height: "65px", width: "200px", lineHeight: "55px" }}>
                            <span>No logo selected</span>
                        </div>
                        <div className="col-md-1" />
                        <div className={!this.props.logo || !this.props.logo.isNew ? "": "hidden"}
                            style={{ display: "inline-flex" }}>
                            <div className={!this.props.logo || this.props.logo.isNew ? "visibilityHidden" : ""}>
                                <button id="btnDeleteLogo"
                                    className="btn btn-secondary-action btn-md push-button"
                                    onClick={this._handleDeleteClick}
                                    tabIndex="-1">Delete
                                </button>
                            </div>
                            <button id="btnBrowse"
                                className="btn btn-primary btn-md push-button"
                                onClick={this._handleBrowseClick}
                                tabIndex="-1">Choose logo
                            </button>
                        </div>
                        <div className={!this.props.logo || !this.props.logo.isNew ? "hidden" : ""}
                            style={{ display: "inline-flex" }}>
                            <button className="btn btn-default btn-md push-button"
                                id="btnCancelLogo"
                                onClick={this._handleLogoCancelClick}
                                tabIndex="-1">Cancel
                            </button>
                            <button className="btn btn-secondary-action btn-md push-button"
                                disabled={!this.props.logo || !this.props.logo.isValid ? "disabled" : ""}
                                id="btnSaveLogo"
                                onClick={this._handleLogoSaveClick}
                                tabIndex="-1">SAVE LOGO
                            </button>
                        </div>
                        <div className={uploadErrorMessage}
                            id="uploadErrorMessage">
                                Logo does not match requirements
                        </div>
                    </div>
                    <div className="visibleHelpText col-md-6">
                        <div><span>IMAGE REQUIREMENTS:</span></div>
                        <div><span>•  Smaller than 1MB</span></div>
                        <div><span>•  Dimensions of 200 PX  x  65 PX or smaller</span></div>
                        <div><span>•  .JPG, .PNG, .GIF FILE FORMAT</span></div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div>
                        <input accept="image/*"
                            className="hidden"
                            id="file"
                            multiple={false}
                            onChange={this._handleFilePickerOnChange}
                            ref={(c) => this.filePicker = c} type="file"/>
                    </div>
                </div>

                <DeleteConfirmationDialog id="deleteConfirmationDialog"
                    title="Confirmation"
                    content="Are you sure you want to delete your custom logo?"
                    show={this.state.showDeleteLogoConfirmationDialog}
                    onCancel={this._hideDeleteLogoConfirmationDialog}
                    onDelete={this.deleteLogo} />
            </div>
        );
    }

    //
    // UI handlers
    //
    _handleLogoSaveClick (e) {
        this.saveLogo();
    }

    _handleDeleteClick (e) {
        this._displayDeleteLogoConfirmationDialog();
    }

    _handleBrowseClick (e) {
        this._emitFilePickerOnClick();
        e.preventDefault();
    }

    _handleFilePickerOnChange () {
        if (this.filePicker.files.length > 0) {
            this._selectLogoFile(this.filePicker.files[0]);
        }
    }

    _handleLogoCancelClick (e) {
        this.props.getLogo(this.props.organizationId);
    }

    saveLogo() {
        this._displayPopupOverlay("Uploading logo...");

        this.props.save(this.props.organizationId, this.props.logo);
    }

    deleteLogo() {
        this.props.delete(this.props.organizationId);
    }

    _emitFilePickerOnClick() {
        // NOTE. FilePicker does not fire onChange event if a user selects the same file twice.
        // Setting a value to "" (empty string) forces FilePicker to "forget" the previously selected file.
        this.filePicker.value = "";
        this.filePicker.click();
    }

    _selectLogoFile(file) {
        // Read file contents
        const reader = new FileReader();
        const organizationId = this.props.organizationId;

        reader.onloadend = (e) => {
            var image = new Image();
            image.onload = (i) => {
                this.props.setLogo({
                    organizationId,
                    fileType: file.type,
                    fileName: file.name,
                    fileAltName: file.name,
                    file: file,
                    size: file.size,
                    width: image.width,
                    height: image.height,
                    isNew: true
                });

                this.logoPreview.src = image.src;
            };

            image.onerror = (i) => {
                this.props.setLogo({
                    organizationId,
                    fileType: "incorrectType",
                    fileName: file.name,
                    fileAltName: file.name,
                    file: null,
                    size: 0,
                    width: 0,
                    height: 0,
                    isNew: true
                });

                this.logoPreview.src = null;
            };

            image.src = e.target.result;
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    }

    _displayPopupOverlay(overlayMessage) {
        this.setState({ overlayMessage });
    }

    _hidePopupOverlay() {
        this.setState({ overlayMessage: "" });
    }

    _displayDeleteLogoConfirmationDialog() {
        this.setState({ showDeleteLogoConfirmationDialog: true });
    }

    _hideDeleteLogoConfirmationDialog() {
        this.setState({ showDeleteLogoConfirmationDialog: false });
    }
}

LogoSettings.propTypes = {
    organizationId: PropTypes.number.isRequired,
    settings: PropTypes.instanceOf(Settings),
    getOrganizationSettings: PropTypes.func,
    getLogo: PropTypes.func
};

const mapStateToProps = state => ({
    logo: state.settingsState.logo
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getLogo: (organizationId) => dispatch(actions.getLogo(organizationId)),
        save: (organizationId, logoImage) => dispatch(actions.saveLogo(organizationId, logoImage)),
        delete: (organizationId) => dispatch(actions.deleteLogo(organizationId)),
        setLogo: (value) => dispatch(actions.setLogo(value))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoSettings);

